import request from '@/utils/request'

export function addressDefault (data) {
  return request({
    url: 'address/default',
    method: 'POST',
    params: data
  })
}

export function addressList (data) {
  return request({
    url: 'address/index',
    method: 'get',
    params: data
  })
}

export function addressAdd (data) {
  return request({
    url: 'address/add',
    method: 'POST',
    params: data
  })
}
export function addressUpdate (data) {
  return request({
    url: 'address/update',
    method: 'POST',
    params: data
  })
}

export function addressDelete (id) {
  return request({
    url: 'address/delete',
    method: 'POST',
    params: {
        id: id
    }
  })
}

export function addressDetail (data) {
  return request({
    url: 'address/detail',
    method: 'get',
    params: data
  })
}